const SiteFooter = () => {
  return (
    <footer className="w-full py-4 mt-4 md:mt-6 border-t border-border/40">
      <p className="text-center text-xs text-muted-foreground/70">
        Site réalisé par{" "}
        <a
          href="https://breizh-connect.com"
          target="_blank"
          rel="noopener"
          className="text-muted-foreground hover:text-primary transition-colors"
        >
          Breizh Connect
        </a>
      </p>
    </footer>
  );
};

export default SiteFooter;
